import { CFormTextarea } from '@coreui/react'
import PropTypes from 'prop-types'
import React from 'react'
 
const BulletTextArea = (props) => {
  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role
 
const handleChange = (e) => {
  // Keep normal text entry available for the Assessment modal without
  // changing the legacy auto-bullet behavior for other consumers.
  if (props.assessmentEditor) {
    props?.onChange && props.onChange(e)
    return
  }

  let value = e.target.value
 
  let lines = value.split('\n')
 
  lines = lines.map((line) => {
    const check = line.trim()  
 
    if (check === '') return ''  
 
 
    return line.startsWith('•') ? line : `• ${line}`
  })
 
  const updatedValue = lines.join('\n')
 
  props?.onChange &&
    props.onChange({
      ...e,
      target: {
        ...e.target,
        value: updatedValue,
      },
    })
}
 
// const handleChange = (e) => {
//   const value = e.target.value
 
//   props?.onChange?.({
//     ...e,
//     target: {
//       ...e.target,
//       value,
//     },
//   })
// }
 
  const handleKeyDown = (e) => {
    if (props.assessmentEditor) {
      if (e.key !== 'Enter' || e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return
      }

      const { selectionStart, selectionEnd, value } = e.target

      if (selectionStart !== selectionEnd) return

      const lineStart = value.lastIndexOf('\n', selectionStart - 1) + 1
      const nextLineBreak = value.indexOf('\n', selectionStart)
      const lineEnd = nextLineBreak === -1 ? value.length : nextLineBreak
      const currentLine = value.slice(lineStart, lineEnd)
      const bulletMatch = currentLine.match(/^(\s*)•\s?(.*)$/)

      // Normal lines keep the browser's native Enter behavior.
      if (!bulletMatch) return

      e.preventDefault()

      const [, indentation, bulletContent] = bulletMatch
      let newValue
      let nextCursorPosition

      if (!bulletContent.trim()) {
        // A second Enter on an empty bullet exits the list.
        newValue = value.slice(0, lineStart) + value.slice(lineEnd)
        nextCursorPosition = lineStart
      } else {
        newValue = value.slice(0, selectionStart) +
          `\n${indentation}• ` +
          value.slice(selectionEnd)
        nextCursorPosition = selectionStart + indentation.length + 3
      }

      props?.onChange && props.onChange({
        ...e,
        target: {
          ...e.target,
          value: newValue,
        },
      })

      requestAnimationFrame(() => {
        e.target.setSelectionRange(nextCursorPosition, nextCursorPosition)
      })
      return
    }

    // When user presses Enter → add new bullet automatically
    if (e.key === 'Enter') {
      e.preventDefault()
 
      const { selectionStart, value } = e.target
 
      const newValue =
        value.substring(0, selectionStart) +
        '\n• ' +
        value.substring(selectionStart)
 
      props?.onChange &&
        props.onChange({
          ...e,
          target: {
            ...e.target,
            value: newValue,
          },
        })
    }
  }
 
//   const handleKeyDown = (e) => {
//   if (e.key === 'Enter') {
//     e.preventDefault()
 
//     const { selectionStart, value } = e.target
 
//     const before = value.substring(0, selectionStart)
//     const after = value.substring(selectionStart)
 
//     const newValue = `${before}\n• ${after}`
 
//     props?.onChange?.({
//       ...e,
//       target: {
//         ...e.target,
//         value: newValue,
//       },
//     })
//   }
// }
  return (
    <CFormTextarea
      aria-rowcount={10}
      rows={props?.rows}
      className={props?.className}
      disabled={props?.disabled || false}
      value={props.value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      style={{
        height: props?.height || '300px',
        color: role === 'provider' ? 'white' : 'var(--ui-text-primary, #f3f4f6)',
        background: props?.showTreatmentAsAccordion ? '' : '#8080800d',
        whiteSpace: 'pre-wrap',
        ...props?.style,
      }}
    />
  )
}
 
export default BulletTextArea

BulletTextArea.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  height: PropTypes.string,
  onChange: PropTypes.func,
  rows: PropTypes.number,
  showTreatmentAsAccordion: PropTypes.bool,
  assessmentEditor: PropTypes.bool,
  style: PropTypes.object,
  value: PropTypes.string,
}
